export const OVERVIEW_RECENT_NEWS_LIMIT = 5;

export function mergeOverviewRecentNews<T extends { id: number }>(
  preferred: T[],
  backfill: T[],
  limit = OVERVIEW_RECENT_NEWS_LIMIT,
): T[] {
  if (preferred.length >= limit) {
    return preferred.slice(0, limit);
  }

  const seenIds = new Set(preferred.map(story => story.id));
  const merged = [...preferred];

  for (const story of backfill) {
    if (merged.length >= limit) {
      break;
    }
    if (seenIds.has(story.id)) {
      continue;
    }
    seenIds.add(story.id);
    merged.push(story);
  }

  return merged;
}
